/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Scope_DescInputs */



/**
* | output |
* | --- |
* | "Whether everyone in your organisation can use this type. This cannot be changed later." |
*
* @param {Settings_Template_Scope_DescInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_scope_desc = /** @type {((inputs?: Settings_Template_Scope_DescInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Scope_DescInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Of je hele organisatie dit type kan gebruiken. Dat kan je achteraf niet meer wijzigen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Si toute votre organisation peut utiliser ce modèle. Vous ne pourrez plus modifier ce choix par la suite.")
	return /** @type {LocalizedString} */ ("Whether everyone in your organisation can use this type. This cannot be changed later.")
});